/**
 * Created by 310293471 on 19/03/2018.
 */
export class ModalLoaderPayload {
  public title: string;
  public classes: string;
  public backdropAllowed: boolean;

  constructor(title: string) {
    this.title = title;
  }

  static builder() {
    return new this(null);
  }

  setTitle(title: string) {
    this.title = title;
    return this;
  }

  public setCssClasses(...cssClasses: string[]) {
    this.classes = cssClasses.join(' ');
    return this;
  }

  public setBackdropAllowed(isAllowed: boolean) {
    this.backdropAllowed = isAllowed;
    return this;
  }
}
